import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const DOCS_URL = process.env.REACT_APP_DOCS_URL || 'http://localhost:5000/documents';

const api = axios.create({
    baseURL: API_URL
});

export default api;
export { API_URL, DOCS_URL };
